import { maxLength } from "widgets/forms/validators/validators";
import { fetchVersionsWithPrefix } from "reducers/CreativeVersions";
import { get } from "lodash";

const VERSION_NAME_PREFIX_MAX_LENGTH = 200;

export const versionNamePrefixLength = maxLength(VERSION_NAME_PREFIX_MAX_LENGTH);

export function hasAssets(value, allValues, props, name){
	// This is a very basic check that any value was provided in a field array
	if(!value?.length || !value?.some(item => item)){
		return "At least one asset must be provided.";
	}
}

export function getIdentity(value){
	/*
		This function is used to check for value uniqueness.

		If `value` is an object with an `id` property, we use that, otherwise we assume it's
		a string primative and use the value directly.
	*/
	return value?.id || value;
}

export function valueUnique(value, allValues, props, name){
	// This validator checks that no values are duplicated in a FieldArray.
	if(!value){
		// This is just for duplicate substantial values, so don't compute or return an error if it's empty.
		return;
	}

	/*
		`name` is a string formatted like:
			"variables.variableName[fieldArrayIndex]"

		We have to extract the variable name and index manually
	*/
	const openBracketIndex = name.lastIndexOf("[");
	const closeBracketIndex = name.lastIndexOf("]");

	const fieldArrayIndex = parseInt(name.substring(openBracketIndex + 1, closeBracketIndex));
	const fieldArrayName = name.substring(0, openBracketIndex);

	const otherValues = [...(get(allValues, fieldArrayName) || [])];
	otherValues.splice(fieldArrayIndex, 1); /*
		Remove this item's value, so that `find` can fail fast, as soon as we see the value again.
	*/

	const valueIdentity = getIdentity(value);

	const hasDuplicate = otherValues.find((item) => {
		return getIdentity(item) === valueIdentity;
	});

	if(hasDuplicate){
		return "Asset has been added more than once";
	}
}

export async function versionPrefixExists(dispatch, libraryId, creativeId, versionNamePrefix){
	let versions = await dispatch(fetchVersionsWithPrefix(libraryId, [creativeId], versionNamePrefix));
	if(versions.length){
		throw {
			versionNamePrefix: "An existing version already exists under this name",
		};
	}
}

export async function asyncValidateVersionPrefixExists(values, dispatch, props, fieldName){
	const { libraryId, versionGenerationState } = props;
	const { creatives } = versionGenerationState;
	let versions = await dispatch(fetchVersionsWithPrefix(libraryId, creatives.map(creative => creative.id), values[fieldName]));
	if(versions.length){
		throw {
			[fieldName]: "Versions with this prefix already exist. Please enter a new, unique name",
		};
	}
}
